import { Fragment } from 'react';

// Styles used for providing the structure of individual pages during
// the onboarding flow.

export const OnboardingPageContent = Fragment;
